import * as i0 from "@angular/core";
var StorageService = /** @class */ (function () {
    function StorageService() {
        /**
         * Storage method sessionstorage | localstorage
         */
        this.storageType = 'localstorage';
        /**
         * Used to mock storage when not available
         */
        this.items = {};
        if (!this.storageEnabled) {
            try {
                if (this.storageType === 'sessionstorage') {
                    window.sessionStorage.setItem('test', 'test');
                    window.sessionStorage.removeItem('test');
                    this.storage = window.sessionStorage;
                }
                else {
                    window.localStorage.setItem('test', 'test');
                    window.localStorage.removeItem('test');
                    this.storage = window.localStorage;
                }
                this.localStorage = window.localStorage;
                this.sessionStorage = window.sessionStorage;
                this.storageEnabled = true;
            }
            catch (e) {
                this.storage = this.storageFallback();
            }
        }
    }
    /**
     * A basic fallback to mock session or localStorage objects in browser memory
     *
     * @return: {{setItem: ((key, val) => any); getItem: ((key) => any); removeItem: ((key) =>
     * any); clear: (() => {})}}
     */
    StorageService.prototype.storageFallback = function () {
        var _this = this;
        return {
            setItem: function (key, val) { return _this.items[key] = val; },
            getItem: function (key) { return _this.items[key]; },
            removeItem: function (key) {
                if (_this.items[key]) {
                    try {
                        delete _this.items[key];
                    }
                    catch (e) {
                        _this.items[key] = null;
                    }
                }
            },
            clear: function () { return _this.items = {}; }
        };
    };
    /**
     * use common function to set storage data
     * param key - key should be should be the key string
     * param val - val should be the 'stringified' JSON
     */
    StorageService.prototype.set = function (key, val, driver) {
        // remove the key if it already exists
        this.remove(key, driver);
        val = typeof val === 'string' ? val : JSON.stringify(val);
        // use configured storage type or passed on
        driver ? driver.setItem(key, val) : this.storage.setItem(key, val);
    };
    /**
     * use common public static to get session data
     */
    StorageService.prototype.get = function (key, driver) {
        // return object string
        var returnObjStr;
        returnObjStr = driver ? driver.getItem(key) : this.storage.getItem(key);
        try {
            returnObjStr = JSON.parse(returnObjStr);
        }
        catch (e) {
        }
        if (returnObjStr === null) {
            returnObjStr = undefined;
        }
        return returnObjStr;
    };
    /**
     * public static to remove session data
     */
    StorageService.prototype.remove = function (keys, driver) {
        var _this = this;
        keys = typeof keys === 'string' ? [keys] : keys;
        keys.map(function (k) {
            try {
                driver ? driver.removeItem(k) : _this.storage.removeItem(k);
            }
            catch (e) {
            }
        });
    };
    /**
     * public static to remove ALL session data
     */
    StorageService.prototype.clearAll = function (driver) {
        driver ? driver.clear() : this.storage.clear();
    };
    StorageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function StorageService_Factory() { return new StorageService(); }, token: StorageService, providedIn: "root" });
    return StorageService;
}());
export { StorageService };
